import { useLocation } from "react-router-dom";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO, QUERY_COURSE_ID, QUERY_PARENT_ID } from "@/const.ts";
import { useCollection, useFullItems } from "@/hooks";
import { useMemo } from "react";
import { Collection, CollectionItem, CollectionResponse } from "@/api";

const EMPTY_ARRAY: CollectionItem[] = [];

const getItemsFromCourse = (course: CollectionResponse) => {
  const result: CollectionItem[] = [];

  const processItems = (items: CollectionItem[], childCollections: Record<number, Collection>) => {
    for (const item of items) {
      if (item.Type === ITEM_TYPE_VIDEO) {
        result.push(item);
      } else if (item.Type === ITEM_TYPE_COLLECTION) {
        const collection = childCollections[parseInt(item.ChildId)];
        if (collection && Array.isArray(collection.Items)) {
          processItems(collection.Items, childCollections);
        }
      }
    }
  };

  if (course && Array.isArray(course.Items)) {
    processItems(course.Items, course.ChildCollections ?? {});
  }

  return result;

}

export const useUpNext = ({ itemId }: { itemId: number }) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const courseId = query.get(QUERY_COURSE_ID);
  const collectionId = query.get(QUERY_COURSE_ID) || query.get(QUERY_PARENT_ID);


  const { data: upNextCollection } = useCollection(
    collectionId ? parseInt(collectionId) : 0,
  );
  const { getFullItem } = useFullItems({
    videos: upNextCollection?.ChildVideos ?? {},
    collections: upNextCollection?.ChildCollections ?? {},
  });

  const nextItems = useMemo(() => {
    if (!upNextCollection?.Items) {
      return EMPTY_ARRAY;
    }
    let upNextItems = upNextCollection.Items;

    if(courseId) {
      upNextItems = getItemsFromCourse(upNextCollection);
    }

    const idx = upNextItems.findIndex(
      (i) => i.ChildId == itemId.toString(),
    );
    if (idx == null) {
      // Couldn't find the current item - Unexpected
      return upNextItems;
    }
    // All items following the current video
    return upNextItems.slice(idx + 1).filter(
      (i) => i.Type === ITEM_TYPE_VIDEO,
    );
  }, [upNextCollection?.Items, itemId, courseId]);

  return {
    nextItems,
    getFullItem,
    collectionId,
    isLoading: !!collectionId && !upNextCollection,
    upNextCollection,
    courseId,
  };
};
